export default function SvgClose(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.2344 2.7998L2.79935 16.2348" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M16.1997 16.235L2.76465 2.79993" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
    );
}
